import { useEffect } from "react";
import { useSelector } from "react-redux";
import { bailiffDialogUrlAudioSelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
//
//component
//redux
//selector
//actions
const TriggerInit = ({ setAudio }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const url = useSelector(bailiffDialogUrlAudioSelector);
  // -------------------------- USE EFFECT ---------------------
  // trigger url.
  useEffect(() => {
    if (!url) return;
    const audio = new Audio(url);
    const sub = audio.addEventListener("canplay", () => {
      setAudio(audio);
    });

    return () => {
      // Pause the audio, remove its source to release resources.
      audio.removeEventListener("canplay", sub);
      audio.pause();
      audio.removeAttribute("src");
      audio.load();
    };
  }, [setAudio, url]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
